export enum PromotionAppliesTo {
  section = 0,
  assignment = 1,
  room_state = 2,
}

/**
 * the type is defined by the ID of the document(s) in /promotion collection
 * each type should have unique rules/validation associated with it
 */
export enum PromotionType {
  /** when applied to  a section, all assignments in the section are free */
  nFreeSections = 'nFreeSections',
}
